var pipe = function pipe() {
  var validators = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    validators[_i] = arguments[_i];
  }
  return function () {
    var fieldValidatorArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      fieldValidatorArgs[_i] = arguments[_i];
    }
    return validators.reduce(function (error, validator) {
      return error || validator.apply(void 0, fieldValidatorArgs);
    }, undefined);
  };
};
export default pipe;
export { pipe };